import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { useTranslate } from '@growtherapy/i18n';

import { VisitorDrawerState, visitorDrawerStateAtom } from '../state';
import { useReflectionDrawerVisibility } from './useReflectionDrawerVisibility';

/**
 * Utility hook encapsulating shared logic for reflection topics drawer controls.
 *
 * @returns An object containing the necessary props for the reflection topics drawer control.
 * @property helperText - The text to display in the tooltip or menu item.
 * @property isDrawerOpen - Whether the reflection topics drawer is already open.
 * @property onClick - The function to call when the drawer control is clicked.
 * @property shouldShow - Whether the control should render.
 */
export function useReflectionTopicsDrawerControl() {
  const t = useTranslate();
  const [drawerState, setDrawerState] = useAtom(visitorDrawerStateAtom);
  const { shouldShow } = useReflectionDrawerVisibility();
  const isDrawerOpen = drawerState === VisitorDrawerState.REFLECTION_TOPICS;

  const onClick = useCallback(() => {
    setDrawerState((prev) =>
      prev === VisitorDrawerState.REFLECTION_TOPICS ? null : VisitorDrawerState.REFLECTION_TOPICS,
    );
  }, [setDrawerState]);

  return {
    helperText: isDrawerOpen
      ? t('telehealth-core:controls.closeSessionPrep')
      : t('telehealth-core:controls.openSessionPrep'),
    isDrawerOpen,
    onClick,
    shouldShow,
  };
}
